import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { IRestaurantDetail } from "../models/IRestaurantDetail";
import { getRestaurantList } from "../services/restaurants";
import { S3_IMAGE_BASE_URL } from "../services/config";
import { getDefaultAddress, isLoggedIn } from "../utils/tokenUtils";
import { useLanguage } from "../context/LanguageContext";
import "../styles/style.css";

function AllRestaurants() {
  const [restaurants, setRestaurants] = useState<IRestaurantDetail[]>([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const { t } = useLanguage();

  useEffect(() => {
    const load = async () => {
      const townId = isLoggedIn()
        ? getDefaultAddress()?.townId
        : localStorage.getItem("guestTownId") ?? undefined;
      const res = await getRestaurantList(townId);
      setRestaurants(res.data.items);
    };
    // catch olmadan hata "unhandled rejection" olarak runtime overlay'e düşüyor
    // ve loading hiç kapanmadığı için iskelet ekranda kalıyordu.
    load()
      .catch(() => setRestaurants([]))
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <div className="row g-3 mt-2">
        {Array.from({ length: 6 }).map((_, i) => (
          <div key={i} className="col-12 col-sm-6 col-lg-4">
            <div className="card border-0 rounded-4 shadow-sm overflow-hidden h-100">
              <div className="skeleton" style={{ height: "160px", borderRadius: 0 }} />
              <div className="card-body px-3 py-2 pb-3">
                <div className="skeleton mb-2" style={{ height: "16px", width: "65%" }} />
                <div className="skeleton" style={{ height: "13px", width: "45%" }} />
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="row g-3 mt-2">
      {restaurants.map((r) => (
        <div key={r.id} className="col-12 col-sm-6 col-lg-4">
          <div
            className="card border-0 rounded-4 shadow-sm overflow-hidden h-100 restaurant-card"
            onClick={() => navigate(`/restaurants/${r.id}`)}
          >
            <div className="position-relative" style={{ height: "160px", background: "#f0f0f0" }}>
              {r.restourantFeatureadImagePath ? (
                <img
                  src={S3_IMAGE_BASE_URL + r.restourantFeatureadImagePath}
                  alt={r.restourantName}
                  style={{ width: "100%", height: "100%", objectFit: "cover" }}
                />
              ) : r.restourantLogoPath ? (
                <div className="d-flex align-items-center justify-content-center h-100">
                  <img
                    src={S3_IMAGE_BASE_URL + r.restourantLogoPath}
                    alt={r.restourantName}
                    style={{ maxHeight: "110px", maxWidth: "170px", objectFit: "contain" }}
                  />
                </div>
              ) : null}

              {!r.restourantIsEnabled && (
                <div
                  className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
                  style={{ background: "rgba(0,0,0,0.5)" }}
                >
                  <span className="badge bg-dark px-3 py-2" style={{ fontSize: "0.9rem" }}>{t("restaurants.closed")}</span>
                </div>
              )}

              {r.restourantEstDeliveryTime != null && (
                <span
                  className="position-absolute bottom-0 end-0 m-2 badge rounded-pill bg-white text-dark shadow-sm"
                  style={{ fontSize: "0.75rem" }}
                >
                  <i className="bi bi-clock me-1"></i>
                  {r.restourantEstDeliveryTime} {t("common.minutes")}
                </span>
              )}
            </div>

            <div className="card-body px-3 py-2 pb-3">
              <h6 className="fw-bold mb-1 text-truncate">{r.restourantName}</h6>
              <div className="d-flex align-items-center gap-3 small text-muted">
                <span>
                  <i className="bi bi-bag me-1"></i>
                  Min. {r.restourantMinAmount.toFixed(0)}₺
                </span>
                {r.restourantTotalFeedBackPoint != null && r.restourantTotalFeedBackPoint > 0 && (
                  <span>
                    <i className="bi bi-star-fill text-warning me-1"></i>
                    {r.restourantTotalFeedBackPoint.toFixed(1)}
                  </span>
                )}
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

export default AllRestaurants;
